import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20 * 1000, // 20 seconds
      throwOnError: true,
      retry: (failureCount, error: any): boolean => {
        // Don't retry on 4xx errors except 408 (Timeout), 429 (Too Many Requests)
        if (error?.status >= 400 && error?.status < 500 && ![408, 429].includes(error?.status)) {
          return false;
        }

        return failureCount < 3;
      }
    }
  }
});
